import { styled } from '@nykaa/ui-components';

export const Layout = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.surface};
  .capitalize-uppercase {
    p {
      text-transform: lowercase;
      display: inline-block;
      &::first-line {
        text-transform: capitalize;
      }
      &::first-letter {
        text-transform: capitalize;
      }
    }
  }
`;

export const HeaderLayout = styled.div`
  position: relative;
`;

export const CartBodyLayout = styled.div`
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 60px;
  padding-bottom: 60px;
  overflow: auto;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.surface};
  .flip-card {
    perspective: 1000px;
    height: auto;
    .flip-card-back {
      display: none;
      min-height: 150px;
    }
    &.flipped {
      .flip-card-back {
        position: relative;
        display: block;
      }
    }
  }

  .flip-card-inner {
    position: relative;
    transition: transform 0.6s;
    width: 100%;
  }

  .flip-card-front {
    position: relative;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .flip-card-back {
    position: absolute;
    top: 0px;
  }

  .flip-card-back {
    width: 100%;
  }
`;

export const MessageWrapper = styled.div``;

export const Wrapper = styled.div``;

export const FreePickerWrapper = styled.div<{
  cartFreeGiftBanner?: { pickGiftBgImage?: string };
}>`
  background-image: url(${({ cartFreeGiftBanner }) =>
    cartFreeGiftBanner?.pickGiftBgImage});
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: ${({ theme }) => theme.spacing.spacing40};
  cursor: pointer;
  margin: 6px 0px;
`;

export const FreePickerText = styled.div`
  height: 42px;
  display: flex;
  align-items: center;
  padding-left: 70px;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-overflow: ellipsis;
  ${({ theme }) => theme.typography.titleXSmall};
`;

export const ProductLayout = styled.div``;

export const ProductItemLayout = styled.div`
  -moz-backface-visibility: hidden;
`;

export const ProductInnerLayout = styled.div``;

export const FreeProductCard = styled.div``;

export const AuthRedirectionLayout = styled.div``;

export const QuantityLayout = styled.div``;

export const FooterLayout = styled.div`
  position: relative;
  width: 100%;
  bottom: 0;
`;

export const AlertIcon = styled.img``;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PickYourFreeSamplesLayout = styled.div`
  background-color: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) =>
    `${theme.spacing.spacing320} ${theme.spacing.spacing50} ${theme.spacing.spacing50} ${theme.spacing.spacing50}`};
`;

export const PickFreeSamplesShimmerContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing.spacing320} ${theme.spacing.spacing50} ${theme.spacing.spacing0} ${theme.spacing.spacing50}`};
`;

export const MarginDiv = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing160};
`;

export const ScreenReaderLiveRegion = styled.div`
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const DiscountTooltipWrapper = styled.div`
  position: relative;
`;
